"use strict";

var _slicedToArray = require("/builds/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var notice_action_1 = require("../actions/notice.action");
function NotificationList(props) {
  var _ref = (0, hooks_1.useState)([]),
    _ref2 = _slicedToArray(_ref, 2),
    items = _ref2[0],
    setItems = _ref2[1];
  var _ref3 = (0, hooks_1.useState)(true),
    _ref4 = _slicedToArray(_ref3, 2),
    loading = _ref4[0],
    setLoading = _ref4[1];
  (0, hooks_1.useEffect)(function () {
    var noticeList = (0, notice_action_1.fetchNoticeList)();
    setTimeout(function () {
      setItems(noticeList);
    }, 50);
  }, []);
  var handleNotificationRanding = (0, hooks_1.useCallback)(function (item) {
    return function (e) {
      if (!item.rending_url) {
        e.preventDefault();
      }
    };
  }, []);
  /**
   * 휠클릭
   */
  var handleNotificationRandingWheelClick = (0, hooks_1.useCallback)(function (item) {
    return function (e) {
      if (e.button === 1) {
        handleNotificationRanding(item)(e);
      }
    };
  }, []);
  return (0, preact_1.h)("div", {
    className: "serviceNotice"
  }, (0, preact_1.h)("div", {
    className: 'scrollarea scroll_area'
  }, (0, preact_1.h)("ul", null, items.map(function (item, index) {
    return (0, preact_1.h)("li", {
      key: index
    }, (0, preact_1.h)("a", {
      href: item["i_link_url"],
      target: "_blank"
    }, (0, preact_1.h)("p", {
      className: "txt"
    }, item["i_title"]), (0, preact_1.h)("span", {
      className: "date"
    }, item["i_reg_date"])));
  }))));
}
exports.default = NotificationList;